"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MedicalCodesManager = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var ui_common_1 = require("@codametrix/ui-common");
var __1 = require("../..");
var show_results_1 = require("../transactions/transaction/show-results");
var ui_common_2 = require("@codametrix/ui-common");
var code_field_component_1 = __importDefault(require("../code-bench-panel/code-layer/field-components/code-field-component"));
var ChargeSessionCodeType = ui_common_1.commonEnums.ChargeSessionCodeType, CodeSearchType = ui_common_1.commonEnums.CodeSearchType;
var MedicalCodesManager = function (_a) {
    var codeList = _a.codeList, codeType = _a.codeType, editMode = _a.editMode, searchResults = _a.searchResults, _b = _a.debounceTimeout, debounceTimeout = _b === void 0 ? 200 : _b, fieldDefinitions = _a.fieldDefinitions, _c = _a.isSharedInvoice, isSharedInvoice = _c === void 0 ? false : _c, searchResultsLookupKey = _a.searchResultsLookupKey, suggestedCodes = _a.suggestedCodes, transactionGuid = _a.transactionGuid, handleCodeDelete = _a.handleCodeDelete, onCodeSearch = _a.onCodeSearch, onCodeSearchSelection = _a.onCodeSearchSelection, handleCodeChecked = _a.handleCodeChecked, codeDropHandler = _a.codeDropHandler, onAddAllCodes = _a.onAddAllCodes, onRemoveAllCodes = _a.onRemoveAllCodes, codeEdits = _a.codeEdits, _d = _a.autoFocus, autoFocus = _d === void 0 ? false : _d;
    // Refs for interacting with the Lookup component and the CodesManager container
    var lookupRef = react_1["default"].createRef();
    var managerRef = (0, react_1.useRef)(null);
    var isProcedureCode = codeType === ChargeSessionCodeType.PROCEDURE;
    // State for controlling visibility of the search input
    var _e = __read((0, react_1.useState)(ui_common_2.objectUtils.isEmpty(codeList)), 2), isSearchVisible = _e[0], setIsSearchVisible = _e[1];
    // State to manage the list of codes (for reordering)
    var _f = __read((0, react_1.useState)(codeList), 2), codes = _f[0], setCodes = _f[1];
    var shouldShowSearch = function (codeList) {
        return editMode && (!isProcedureCode || ui_common_2.objectUtils.isEmpty(codeList));
    };
    react_1["default"].useEffect(function () {
        setCodes(codeList);
        setIsSearchVisible(shouldShowSearch(codeList));
    }, [codeList]);
    // Handler for clicking on the manager container (opens search if conditions are met)
    var handleManagerClick = function () {
        if (shouldShowSearch(codeList)) {
            setIsSearchVisible(true);
            if (lookupRef.current) {
                lookupRef.current.focus(); // Set focus on the Lookup input
            }
        }
    };
    // Handler to reorder codes when dragged and dropped
    var handleCodeDrop = function (dragIndex, hoverIndex) {
        var updatedCodes = __spreadArray([], __read(codes), false);
        var _a = __read(updatedCodes.splice(dragIndex, 1), 1), draggedCode = _a[0];
        updatedCodes.splice(hoverIndex, 0, draggedCode);
        setCodes(updatedCodes);
        codeDropHandler(updatedCodes);
    };
    // Determine if the codes are draggable (based on edit mode and code type)
    var isDraggable = editMode && !isProcedureCode && codeList.length > 1;
    // Generate the view for the list of codes using CodeChip components
    var codesView = ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: codes.map(function (medicalCode, idx) { return ((0, jsx_runtime_1.jsx)(code_field_component_1["default"], { chipProps: {
                code: medicalCode.code,
                codeType: medicalCode.codeType,
                editable: editMode,
                handleCodeDelete: handleCodeDelete,
                sequence: idx,
                onDrop: handleCodeDrop,
                isDraggable: isDraggable,
                active: medicalCode === null || medicalCode === void 0 ? void 0 : medicalCode.active,
                shared: medicalCode === null || medicalCode === void 0 ? void 0 : medicalCode.shared,
                isSharedInvoice: isSharedInvoice,
                handleCodeChecked: handleCodeChecked,
                description: medicalCode === null || medicalCode === void 0 ? void 0 : medicalCode.description,
                evidence: medicalCode === null || medicalCode === void 0 ? void 0 : medicalCode.evidence,
                codeEdits: codeEdits
            } }, "".concat(medicalCode.code, "-").concat(idx))); }) }));
    // Filter field definitions based on the selected code type
    var fieldDefinition = fieldDefinitions.filter(function (def) { return def.label.toLowerCase() === codeType.toLowerCase(); });
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "codes-manager ".concat(codeType), ref: managerRef, onClick: handleManagerClick }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "codes-manager-left" }, { children: [(0, jsx_runtime_1.jsx)(__1.Conditional, __assign({ every: [(codes === null || codes === void 0 ? void 0 : codes.length) !== 0] }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "code-list" }, { children: codesView })) })), (0, jsx_runtime_1.jsx)(__1.Conditional, __assign({ on: isSearchVisible }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "code-search" }, { children: (0, jsx_runtime_1.jsx)(__1.SuggestedLookup, { ref: lookupRef, actionPrefix: "", placeholderText: ui_common_2.objectUtils.isEmpty(codeList)
                                    ? "Add ".concat(codeType.toLowerCase())
                                    : '', debounceTimeout: debounceTimeout, FieldDefinitions: fieldDefinition, shouldShowResults: show_results_1.shouldShowResults, autoFocus: autoFocus, onSearch: onCodeSearch, onSearchSelection: onCodeSearchSelection, handleCodeDelete: handleCodeDelete, searchResults: searchResults, disabled: !editMode, searchResultsLookupKey: searchResultsLookupKey, actionNameForDD: isSharedInvoice
                                    ? '~Focus code search (Shared)'
                                    : '~Focus code search (General)', suggestedCodes: suggestedCodes, allowCodeRemove: !isSharedInvoice &&
                                    ui_common_1.caseUtils.getCodeTypeShortName(codeType) !== CodeSearchType.CPT, transactionGuid: transactionGuid, onAddAllCodes: onAddAllCodes, onRemoveAllCodes: onRemoveAllCodes }) })) }))] })), (0, jsx_runtime_1.jsx)(__1.Conditional, __assign({ on: editMode &&
                    (!isProcedureCode ||
                        (isProcedureCode && ui_common_2.objectUtils.isEmpty(codeList))) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "codes-manager-right" }, { children: (0, jsx_runtime_1.jsx)(__1.CMXIcon, { svgIconName: "BiomeChevronDownSVG20", svgIconSize: "16", svgIconClass: "select-chevron" }) })) }))] })));
};
exports.MedicalCodesManager = MedicalCodesManager;
//# sourceMappingURL=medicalcodes-manager.js.map